var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"loading-fade"}},[(_vm.visible)?_c('div',{staticClass:"loading-overlay",class:{ 'loading-fullscreen': _vm.fullscreen }},[_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spinner"}),(_vm.text)?_c('p',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }